import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { EntityNotFoundType, NotFoundPage } from "@/pages/not-found/not-found-page";
import { TemplateEditor } from "@/pages/templates-view/components/template-editor";
import { AddToCollectionModal } from "@/components/modal/add-to-collection/add-to-collection-modal";
import { FileUploadRejectedModal } from "@/components/modal/file-upload-rejected/file-upload-rejeted-modal";
import { ImageUploadRejectedModal } from "@/components/modal/image-upload-rejected/image-upload-rejected-modal";
import { DeleteTemplateModal } from "@/components/modal/delete-template/delete-template-modal";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";

export const TemplatesViewPage = observer(function TemplatesViewPage() {
  const { store: appStore } = useAppStore();
  const page = useTabPageStore("templatesViewPage");
  page.useEffects();

  const isSidePanelOpen = appStore.interface.isChatSidebarOpen;

  if (page.showNotFound) {
    return <NotFoundPage entityType={EntityNotFoundType.Template} />;
  }

  return (
    <>
      {page.addToCollectionModal && <AddToCollectionModal store={page.addToCollectionModal} />}
      {page.fileUploadRejectedModal && (
        <FileUploadRejectedModal store={page.fileUploadRejectedModal} />
      )}
      {page.imageUploadRejectedModal && (
        <ImageUploadRejectedModal store={page.imageUploadRejectedModal} />
      )}
      <DeleteTemplateModal store={page.deleteTemplateModal} />
      <TemplateEditor
        isSidePanelOpen={!!isSidePanelOpen}
        templateObservable={page.itemObservable}
        openFileUploadRejectedModal={page.openFileUploadRejectedModal}
        openImageUploadRejectedModal={page.openImageUploadRejectedModal}
        myAccount={page.myAccount}
        goToMention={page.goToMention}
      />
    </>
  );
});
